import classNames from "classnames";
import * as React from "react";
import { Input, Label } from "uxp/components";
import { hasValue, parseValue } from "../../../../util";
import { IBaseFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle, TextAlignEditor } from "../../ui-props/common";
interface IAddSpaceFieldProperty extends IBaseFieldProperty {
	height:number
}

export const Field: React.FunctionComponent<IUIFieldProps<IAddSpaceFieldProperty>> = (props) => {

	let { height } = props.fieldProps || {}

	let styles: React.CSSProperties = {}
	if (hasValue(height)) styles.height = height +"px"

	return (
		<div className={classNames('ui-field', 'add-space', props.mode)} >
			<div style={styles}>
			</div>
		</div >
	)
}


export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<IAddSpaceFieldProperty>> = (props) => {
	return <PropertyContainer>
		<PropertyGroup>
			<PropertyGroupTitle>Add Space</PropertyGroupTitle>
			<Property>
				<PropertyTitle>Height (px)</PropertyTitle>
				<Input
				    type="number"
					value={String(props.uiProps.height) || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { height: Number(s) }))}
				/>
			</Property>
		</PropertyGroup>

	</PropertyContainer>;
}
registerUIField({
	id: 'space',
	description: 'Add Space',
	field: Field,
	propertyEditor: PropertyEditor,
	defaultProps: {

		height:14
	}

});